<template>
    <div class="main-body" >
        <div class="header">退款列表</div>
        <div class="out">

          <div class="search2">

                <el-button size="mini" type="primary" @click.native="toggleModalAdd">查询老人</el-button>
                <div style="float:right">
                    <el-input  placeholder="请输入老人姓名" v-model="elderlyName" clearable style="width:200px;margin-right:10px"></el-input>
                    <el-date-picker
                        v-model="startTime"
                        type="date"
                        style="margin-right:10px;"
                        value-format="yyyy-MM-dd"
                        placeholder="开始日期" class="search">
                    </el-date-picker>
                    <el-date-picker
                        v-model="endTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="结束日期" class="search">
                    </el-date-picker>
                    <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                </div>

                <div style="clear: both;"></div>

            </div>


          <el-table class="table" size="mini" :data="tableData" v-loading="loading" :height="th" border>
            <el-table-column label="姓名" prop="elderlyName" width="100"></el-table-column>
            <el-table-column label="手机号" prop="elderlyDTO.phone"></el-table-column>
            <el-table-column label="身份证号" prop="elderlyDTO.idCard" width="180"></el-table-column>
            <el-table-column prop="returnBalance" label="退款金额（元）" width="150"></el-table-column>
            <el-table-column prop="createTime" :formatter="formatterTime" width="180" label="创建时间"></el-table-column>
          </el-table>

          <div class="page">
            <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination small
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:zoneValue="zoneValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    </div>
</template>

<script>

    import {timeStr,timefilters,getBeforeDate} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                startTime:getBeforeDate(-30),
                endTime:getBeforeDate(0),
                menuButtonList:null,
                disabledAdd:true,
                showModalAdd:false,
                batchDialog:false,
                tableData:null,
                elderlyName:null,
                rechargeType:0,
                batchFileList:[],
                zoneValue:[],
                datetimerangeValue:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                name:'',
            }
        },
        components:{
            Add
        },
        created(){
            this.init();
            this.getList();

            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{

            init(){
                const end= new Date();
                const start=new Date(end.getTime() - 1000 * 60 * 60 * 24 * 30);
                this.datetimerangeValue=[start, end];
            },
            formatterTime(row, column, cellValue) {
                return timefilters(cellValue)
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            getList(){
                this.loading = true;
                var rechargeType=this.rechargeType
                if(rechargeType==0){
                    rechargeType-=1
                }else{
                    rechargeType+=1
                }
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"RefundRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        startTime:this.startTime,
                        endTime:this.endTime,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },


        }
    }
</script>

<style scoped>

</style>
